<template>
  <div class="eachars-box">
    <div :style="{height:'500px',width:'100%'}" ref="myEchart"></div>
  </div>
</template>
<script>
import '../../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
import { trendChartData } from '@/resource/api/ugcIndex.js'

export default {
  data () {
    return {
      chart: null,
      echartBox: null,
      defaultDate: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 7 * 24 * 60 * 60 * 1000).getTime(),
        new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime()
      ],
      dataShow: [],
      form: {
        stageName: this.$store.state.router.anchorId,
        statisticsFields: 'provinceName',
        startTime: '',
        endTime: ''
      }
    }
  },
  mounted () {
    this.chinaConfigure()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    async getItem () {
      this.form.startTime = this.defaultDate[0]
      this.form.endTime = this.defaultDate[1]
      const res = await trendChartData({ ...this.form })
      res.result.items.forEach(item => {
        this.dataShow.push({ name: item.dataKey, value: item.dataValue })
      })
      console.log(this.dataShow, 'dataShowdataShow')

      const setDataOptin = {
        series: [{
          type: 'scatter',
          coordinateSystem: 'geo' // 对应上方配置
        },
        {
          name: '播放量/次', // 浮动框的标题
          type: 'map',
          geoIndex: 0,
          data: this.dataShow
        }
        ]
      }
      this.echartBox.setOption(setDataOptin)
    },
    chinaConfigure () {
      this.getItem()
      const myChart = this.$echarts.init(this.$refs.myEchart) // 这里是为了获得容器所在位置
      window.onresize = myChart.resize
      this.echartBox = myChart
      this.echartBox.setOption({ // 进行相关配置
        title: {
          text: '播放量全国分布',
          left: '2%',
          top: '4%',
          textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
        },
        tooltip: {}, // 鼠标移到图里面的浮动提示框
        legend: {
          right: '50%',
          top: '4%',
          icon: 'rect',
          itemWidth: 12,
          itemHeight: 4,
          textStyle: { color: '#2C3542' },
          data: ['播放量/次']
        },
        dataRange: {
          show: false,
          min: 0,
          max: 1000,
          text: ['High', 'Low'],
          realtime: true,
          calculable: true,
          color: ['orangered', 'yellow', 'lightskyblue']
        },
        geo: { // 这个是重点配置区
          map: 'china', // 表示中国地图
          roam: true,
          label: {
            normal: {
              show: false, // 是否显示对应地名
              textStyle: {
                color: 'rgba(0,0,0,0.4)'
              }
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.2)'
            },
            emphasis: {
              areaColor: null,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
        series: [{
          type: 'scatter',
          coordinateSystem: 'geo' // 对应上方配置
        },
        {
          name: '播放量/次', // 浮动框的标题
          type: 'map',
          geoIndex: 0,
          data: [
          //   {
          //   'name': '北京',
          //   'value': 599
          // }, {
          //   'name': '上海',
          //   'value': 142
          // }, {
          //   'name': '黑龙江',
          //   'value': 44
          // }, {
          //   'name': '深圳',
          //   'value': 92
          // }, {
          //   'name': '湖北',
          //   'value': 810
          // }, {
          //   'name': '四川',
          //   'value': 453
          // }
          ]

        }
        ]
      })
    }
  }
}
</script>
